import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'

import {
  EditChannelAdjustmentDialogComponent,
  EditChannelAdjustmentDialogInput,
  EditChannelAdjustmentDialogResult,
} from './edit-channel-adjustment-dialog.component'

@Injectable()
export class EditChannelAdjustmentDialogService {
  constructor(private dialog: MatDialog) {}

  public open(data: EditChannelAdjustmentDialogInput = {}) {
    const defaultConfig: MatDialogConfig<EditChannelAdjustmentDialogInput> = {
      width: '500px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data,
    }

    return this.dialog.open<
      EditChannelAdjustmentDialogComponent,
      EditChannelAdjustmentDialogInput,
      EditChannelAdjustmentDialogResult
    >(EditChannelAdjustmentDialogComponent, defaultConfig)
  }
}
